import React, { useEffect, useState } from "react";
import Loader from "react-loader-spinner";
import api_key from "../data/api_key";
import newsData from "../data/news_data.json";

const NewsCard = ({ article }) => {
  const date = new Date(article.publishedAt);
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  const day = date.getDate();
  const newDate = day + "-" + month + "-" + year;

  return (
    <div className="news-card">
      <div className="news-left">
        <img src={article.urlToImage} alt="Article Image"></img>
      </div>
      <div className="news-right">
        <h4>
          <a href={article.url} target="blank">
            {article.title}
          </a>
        </h4>
        <p>{article.description ? article.description.substring(0, 150) : "Failed to load"}...</p>
        <h6>{article.author}</h6>
        <h6>{newDate}</h6>
      </div>
    </div>
  );
}

const Cards = (props) => {
  return props.loading ? <Loader type="TailSpin" width={50} height={50} color="#0070f3" />
    :
    props.data ? (props.data.map((article, i) => <NewsCard article={article} key={i} />)) : null;
};

export const News = () => {
  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);

  async function GetNews(search) {
    setLoading(true);

    let date = new Date();
    date.setDate(date.getDate() - 14);
    const year = new Intl.DateTimeFormat("en", { year: "numeric" }).format(date);
    const month = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(date);
    const d = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(date);
    const newDate = `${year}-${month}-${d}`;
    const searchTerm = `(coronavirus OR covid) AND ${search || 'WHO'}`;

    let url = `https://newsapi.org/v2/everything?q=${searchTerm}&sortBy=popularity&searchIn=title&pageSize=5&from=${newDate}&language=en&apiKey=${api_key.api_key}`;

    fetch(url).then(async res => {
      const responseJson = await res.json();
      console.log(responseJson);
      setLoading(false);
      setData(responseJson.articles || []);
    }).catch(err => {
      console.log(err);
      setLoading(false);
    });
  }

  useEffect(() => {
    GetNews("");
  }, []);

  return (
    <div className="news-container">
      <div className="searchBox">
        <input
          className="form-control"
          type="text"
          placeholder="Search State/City"
          onChange={(e) => {
            setSearch(e.target.value);
          }}
        ></input>
        <span
          className="fas fa-search"
          onClick={() => {
            GetNews(search.trim());
          }}
        ></span>
      </div>
      <Cards loading={loading} data={data} />
    </div>
  );
};
